<template>
  <div class="wpArea">

    <div class="area-content">

      <h2 class="normal">编辑板块</h2>

      <div class="normal">板块名：<input type="text" v-model="area_name"></div>
      <el-radio v-model="level" label="板块">板块</el-radio>
      <el-radio v-model="level" label="区域">区域</el-radio>
      <el-radio v-model="level" label="其它">其它</el-radio>
      <el-radio v-model="level" label="职住平衡">职住平衡</el-radio>
      <el-radio v-model="level" label="备份">备份</el-radio>
      <div class="normal">行政区划：<input type="text" v-model="district"></div>
      <div class="normal">板块等级：<input type="text" v-model="area_level"></div>

      <div class="normal">板块介绍：<textarea rows="5" cols="50" v-model="area_des"></textarea></div>
      <!-- <div class="normal">板块交通：<textarea rows="5" cols="50" v-model="traffic"></textarea></div>
      <div class="normal">城市综合体：<textarea rows="5" cols="50" v-model="shopping_mall"></textarea></div>
      <div class="normal">板块教育：<textarea rows="5" cols="50" v-model="education"></textarea></div> -->
      <!-- <div class="normal">建设情况：<textarea rows="5" cols="50" v-model="stage"></textarea></div> -->
      <div class="normal">产业性质：<input type="text" v-model="nature" placeholder="例如高新产业、服务业"></div>
      <!-- <div class="normal">其它配套：<textarea rows="5" cols="50" v-model="other"></textarea></div> -->
      <!-- <div class="normal">政府规划：<textarea rows="5" cols="50" v-model="area_plan"></textarea></div> -->
      <div class="normal">规划等级：<input type="text" v-model="plan_level" placeholder="例如国家级、省级"></div>
      <!-- <div class="normal">占地规模：<input type="text" v-model="space"></div> -->
      <div class="normal">建筑体量(万方)：<input type="text" v-model="square"></div>
      <div class="normal">规划人口(万人)：<input type="text" v-model="population"></div>
      <!-- <div class="normal">投资资金：<input type="number" rows="5" cols="50" v-model="plan_money"></div> -->

      <div class="normal">热度排名：<input type="number" v-model="hot"></div>
      <div class="normal">新房价格：<input type="number" v-model="new_price"></div>

      <!-- <div class="line">----------------板块示意图----------------</div>
      <div class="normal">
        <input type="file" @change="chooseImage" id="area_image">
      </div>
      <div class="imageBoxMini" v-if="area_image.length>0">
        <img :src="area_image" preview="4" preview-text="板块示意图">
        <button @click="delImage('area_image')">删除</button>
      </div>

      <div class="line">----------------板块规划图----------------</div>
      <div class="normal">
        <input type="file" @change="chooseImage" id="plan_image">
      </div>
      <div class="imageBoxMini" v-if="plan_image.length>0">
        <img :src="plan_image" preview="4" preview-text="板块规划图">
        <button @click="delImage('plan_image')">删除</button>
      </div> -->

      <div class="normal">事件日期：
        <div style="width: 200px; display: inline-block">
          <el-input v-model="trendDate" placeholder="格式: 2020-4-9"></el-input>
        </div>
        <el-button type="info" @click="addEvent">添加</el-button>
      </div>
      <div class="normal text">
        <span>事件描述：</span>
        <div class="inputBox">
          <el-input type="textarea" autosize placeholder="请输入描述" v-model="trendEvent"></el-input>
        </div>
      </div>

      <button @click="upToDb" class="up">上传</button>

      <!-- <div class="normal">
        <div v-for="(item,index) in selfTrend" :key="index" class="normal">
          <button @click="delOneTrend(index)">删除</button>
          {{item.date + '：' + item.event}}
        </div>
      </div> -->
      <div style="width: 980px; margin: 30px auto" v-if="selfTrend.length > 0">
        <h3>时间轴</h3>
        <el-table :data="selfTrend" border stripe>
          <el-table-column prop="event" label="事件">
          </el-table-column>
          <el-table-column prop="date" label="日期" width="90">
          </el-table-column>
          <el-table-column label="操作" width="80">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" @click="delOneTrend(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div style="width: 750px; margin: 30px auto" v-if="news.length > 0">
        <h3>相关文章</h3>
        <el-table :data="news" border stripe>
          <el-table-column prop="title" label="标题">
          </el-table-column>
          <el-table-column prop="date" label="日期" width="90">
          </el-table-column>
          <el-table-column label="操作" width="220">
            <template slot-scope="scope">
              <el-button size="mini" type="warning" @click="unBind(scope.row,scope.$index)">解绑</el-button>
              <el-button size="mini" type="danger" @click="passOneNews(scope.row,scope.$index)">排除</el-button>
              <el-button size="mini" type="text" @click="currentNews = scope.row" v-if="scope.row.summary">已编辑</el-button>
              <el-button size="mini" type="primary" @click="currentNews = scope.row" v-else>编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="image-background" v-if="currentNews">
        <div class="edit-area">
          <div class="edit-left">
            {{currentNews.content}}
          </div>
          <textarea class="edit-right" v-model="currentNews.summary"></textarea>
        </div>
        <div class="control">
          <el-button size="mini" type="warning" @click="currentNews = null">取消</el-button>
          <el-button size="mini" type="primary" @click="saveEdit">保存</el-button>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        level: '',     // 级别：区域、板块
        area_id: '',
        area_name: '',
        area_des: '',
        area_level: '',
        area_image: '',
        plan_image: '',
        district: '',

        traffic: '',
        shopping_mall: '',
        education: '',
        stage: '',
        nature: '',
        other: '',
        area_plan: '',
        plan_level: '',
        plan_money: '',

        space: '',
        square: '',
        population: '',

        selfTrend: [],
        trendDate: '',
        trendEvent: '',

        news: [],
        currentNews: null,

        hot: '',
        new_price: '',

        modelMap: {
          '杭州': 'WpAreaModel',
          '苏州': 'SzAreaModel',
          '天津': 'TjAreaModel',
          '绍兴': 'SxAreaModel',
          '宁波': 'NbAreaModel',
        },
        
      }
    },

    beforeRouteEnter(to, from, next) {
      if(from.name === 'login') {
        to.meta.isBack = true;
      }
      next();
    },
    activated() {
      if(!this.$route.meta.isBack){
        let origin = this.$options.data();
        Object.assign(this.$data, origin)
        this.init();
      }
      this.$route.meta.isBack=false
    },
    methods: {
      // 查询已有板块
      init() {
        let that = this
        let obj = that.$route.params
        console.log('obj', obj)
        if (obj.id) {
          that.$axios.get(that.$url_prefix + 'queryAreaDetail', {
            params: {
              area_id: obj.id
            }
          }).then(function (response) {
            console.log('query area res', response);
            let res = response.data.data;
            that.area_id = res.id;
            that.level = res.level;
            that.area_name = res.area_name;
            that.area_des = res.area_des || '';
            that.area_image = res.area_image || '';
            that.plan_image = res.plan_image || '';
            that.district = res.district || '';
            // that.traffic = res.traffic || '';
            // that.shopping_mall = res.shopping_mall || '';
            // that.education = res.education || '';
            // that.stage = res.stage || '';
            that.nature = res.nature || '';
            // that.other = res.other || '';
            that.area_plan = res.area_plan || '';
            that.area_level = res.area_level || '';
            that.plan_level = res.plan_level || '';
            that.space = res.space || '';
            that.square = res.square || '';
            that.population = res.population || '';
            that.plan_money = res.plan_money || '';
            that.selfTrend = res.selfTrend || [];
            that.news = res.news || [];
            that.hot = res.hot || '';
            that.new_price = res.new_price || '';
          }).catch(function (response) {
            that.$message.error('请求数据失败');
            console.log('query area fail', response)
          })
        }
      },

      // 上传数据库
      upToDb() {
        let that = this
        let obj = {}

        if (that.area_name === '') {
          that.$message.error('板块名必填')
          return
        }

        if (that.area_id.length > 0) {
          obj.id = that.area_id
        }
        obj.level = that.level
        obj.area_image = that.area_image
        obj.plan_image = that.plan_image
        obj.area_name = that.area_name
        obj.area_des = that.area_des
        obj.area_level = that.area_level
        obj.district = that.district
        // obj.traffic = that.traffic
        // obj.shopping_mall = that.shopping_mall
        // obj.education = that.education
        // obj.other = that.other
        // obj.stage = that.stage
        obj.nature = that.nature
        obj.area_plan = that.area_plan
        obj.plan_level = that.plan_level
        obj.space = that.space
        obj.square = that.square
        obj.population = that.population
        obj.plan_money = that.plan_money
        obj.hot = that.hot
        obj.new_price = that.new_price
        
        let param = {
          'db': that.modelMap[that.$store.state.Counter.city],
          'model': 'edit',
          'item': JSON.stringify(obj)
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
          console.log('发送板块返回', res)
          that.$router.push({
            path: '/IndexPage'
          })
        }).catch(function (res) {
          console.log('上传板块失败', res)
        })
      },

      // 选择图片
      chooseImage(event) {
        let that = this
        let option = {
          file: event.target.files[0],
          head_name: 'area',
        }
        that.$uploadImage(option).then(function (res) {
          console.log('upload back', res)
          if (!res) {
            console.log('upload fail')
            return false;
          }

          if (origin === 'area_image') {
            that.area_image = res
            that.$previewRefresh()
          } else if (origin === 'plan_image') {
            that.plan_image = res
            that.$previewRefresh()
          }

        }).catch(function (res) {
          console.log('upload fail', res)
        })
      },

      delImage(from) {
        if (from === 'area_image') {
          this.area_image = ''
        } else if (from === 'plan_image') {
          this.plan_image = ''
        }
      },

      addEvent() {
        let that = this;
        if (that.area_id && that.trendDate && that.trendEvent) {
          let comTime = that.trendDate;
          let re = /(^\w{4}$|^\w{4}-\w{1,2}$|^\w{4}-\w{1,2}-\w{1,2}$)/;
          if (!re.test(comTime)) {
            that.$message.error('预计建成时间格式不对');
            return false;
          }
          let date = that.formatDate(comTime);
          let obj = {
            event: that.trendEvent,
            date: date,
            area_id: that.area_id
          }
          let param = {
            'db': 'WpEventModel',
            'model': 'edit',
            'item': JSON.stringify(obj)
          }
          that.$axios.post(that.$url_prefix + 'updateData', param).then(res => {
            console.log('update trend', res)
            that.init()
          }).catch(err => {
            console.log('update trend fail', err)
          })
        }
      },
      delOneTrend(index) {
        let that = this;
        that.$axios.post(that.$url_prefix + 'delete', {
          'db': 'WpEventModel',
          'items': JSON.stringify([that.selfTrend[index]])
        }).then(function (res) {
          console.log('删除fanhui', res)
          that.selfTrend.splice(index, 1);
        }).catch(function (res) {
          console.log('删除失败', res)
        })
      },
      addEventNext(date, event) {
        let that = this;
        let arr = date.split('-');
        if (arr[1] && arr[1].length === 1) {
          arr[1] = '0' + arr[1];
        }
        if (arr[2] && arr[2].length === 1) {
          arr[2] = '0' + arr[2];
        }
        date = arr.join('-');
        
        if (that.area_id) {
          let obj = {
            event: event,
            date: date,
            area_id: that.area_id
          }
          let param = {
            'db': 'WpEventModel',
            'model': 'edit',
            'item': JSON.stringify(obj)
          }
          that.$axios.post(that.$url_prefix + 'updateData', param).then(res => {
            console.log('update trend', res)
            that.init()
          }).catch(err => {
            console.log('update trend fail', err)
          })
        }
      },

      passOneNews(value, index) {
        let that = this;
        let obj = {
          id: value.id,
          status: 'pass'
        }
        let param = {
          'db': 'GovDetailModel',
          'model': 'edit',
          'item': JSON.stringify(obj)
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(res => {
          that.news.splice(index,1);
        }).catch(err => {
          console.log('pass fail', err);
          that.$message.error('操作失败');
        })
      },
      unBind(value, index) {
        let that = this;
        if (that.area_id) {
          let area = value.area.filter(x => x !== that.area_id);
          let obj = {
            id: value.id,
            area: area
          }
          let param = {
            'db': 'GovDetailModel',
            'model': 'edit',
            'item': JSON.stringify(obj)
          }
          that.$axios.post(that.$url_prefix + 'updateData', param).then(res => {
            that.news.splice(index,1);
          }).catch(err => {
            console.log('pass fail', err);
            that.$message.error('操作失败');
          })
        }
      },
      saveEdit() {
        let that = this;
        let data = that.currentNews;
        let summary = data.summary;
        if (summary) {
          let obj = {
            id: data.id,
            summary: summary
          }
          let param = {
            'db': 'GovDetailModel',
            'model': 'edit',
            'item': JSON.stringify(obj)
          }
          that.$axios.post(that.$url_prefix + 'updateData', param).then(res => {
            if (that.area_id) {
              let objj = {
                event: summary,
                date: that.formatDate(data.date),
                area_id: that.area_id
              }
              let paramm = {
                'db': 'WpEventModel',
                'model': 'edit',
                'item': JSON.stringify(objj)
              }
              that.$axios.post(that.$url_prefix + 'updateData', paramm).then(res => {
                console.log('update trend', res)
                that.currentNews = null;
                that.init()
              }).catch(err => {
                console.log('update trend fail', err)
              })
            }
          }).catch(err => {
            console.log('edit fail', err);
            that.$message.error('操作失败');
          })
        } else {
          that.$message.error('请编辑');
        }
      },

      formatDate(date) {
        let arr = date.split('-');
        if (arr[1] && arr[1].length === 1) {
          arr[1] = '0' + arr[1];
        }
        if (arr[2] && arr[2].length === 1) {
          arr[2] = '0' + arr[2];
        }
        return arr.join('-');
      }

    }
  }

</script>

<style scoped>
  .wpArea {
    text-align: center;
    overflow: hidden;
  }

  .line {
    margin-top: 20px;
    color: #ccc;
  }

  img {
    height: 100px;
    width: 100px;
    vertical-align: bottom;
  }

  .up {
    margin-top: 20px;
    width: 150px;
    height: 50px;
    border-radius: 10px
  }

  .inputBox {
    display: inline-block;
    width: 300px;
  }

  .image-background {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background-color: rgba(169, 169, 169, 0.8);
    z-index: 999;
  }
  .edit-area {
    display: flex;
    width: 100%;
    height: 80%;
    align-items: center;
    justify-content: space-around;
  }
  .edit-left {
    width: 40%;
    height: 80%;
    background-color: #ffffff;
    overflow-y: auto;
    white-space: pre-wrap;
    text-align: left;
    padding: 0 10px;
  }
  .edit-right {
    width: 40%;
    height: 80%;
    resize: none;
    font-size: 20px;
  }

</style>



// WEBPACK FOOTER //
// src/page/wpArea.vue